import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Analytics } from '@vercel/analytics/react';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App path={window.location.pathname} />
    <Analytics />
  </React.StrictMode>
);

// Production builds contain prerendered HTML; the development server starts empty.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
